import { tenantConstants } from './constants';
export class ApiHeaders {
  public static getCommonHeaders(): { 'Content-Type': string } {
    return {
      'Content-Type': 'application/json'
    };
  }

  public static getAuthHeader(): {
    'x-arcauthtenantid': string;
  } {
    return {
      'x-arcauthtenantid': tenantConstants.tenantValue
    };
  }

  public data = {};
}
